export function ErrorBanner({
  message,
  onRetry,
}: {
  message: string;
  onRetry?: () => void;
}): JSX.Element {
  return (
    <div
      style={{
        background: 'var(--c-danger-bg)',
        border: '1px solid var(--c-danger-border)',
        borderRadius: 'var(--radius-md)',
        padding: 12,
        color: 'var(--c-danger)',
      }}
    >
      <div style={{ fontSize: 13 }}>{message}</div>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          style={{
            marginTop: 8,
            background: 'transparent',
            border: '1px solid var(--c-danger)',
            borderRadius: 6,
            padding: '4px 10px',
            cursor: 'pointer',
            color: 'var(--c-danger)',
          }}
        >
          Retry
        </button>
      )}
    </div>
  );
}
